<template>
    <div v-show="shouldShow" class="mb-3 review-el">
        <div
            class="text-subtitle-2 font-weight-regular text--secondary d-flex mb-1"
        >
            <div
                v-html="label || directions"
                :class="{ 'flex-grow-1': !showEditButton }"
            ></div>
            <v-btn
                v-if="showEditButton"
                class="ml-2"
                icon
                @click="goToPage()"
                color="black"
                aria-label="Edit"
            >
                <v-icon> mdi-square-edit-outline </v-icon>
            </v-btn>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'TypeReview',
    props: {
        label: {
            type: String
        },
        directions: {
            type: String
        },
        pageNumber: {
            type: Number,
            required: false
        },
        shouldShow: {
            type: Boolean,
            default: false
        },
        showEditButton: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        goToPage() {
            this.$emit('goToPage', this.pageNumber);
        }
    }
};
</script>

<style lang="scss" >
.review-el .hide-review{
    display: none !important;
}
</style>
